import axios from "axios";

// Creiamo un'istanza di Axios con la configurazione di base
const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Usa la variabile d'ambiente per la base URL
  withCredentials: true, // Necessario per inviare i cookie di sessione
});

// Funzione per il login dell'utente
export const loginUser = (credentials) => API.post("/api/auth/login", credentials);

// Funzione per ottenere la sessione utente attuale
export const getSession = () => API.get("/api/auth/session");

// Funzione per il logout dell'utente
export const logoutUser = () => API.post("/api/auth/logout");

// Funzione per ottenere l'elenco dei corrieri da MongoDB
export const getDrivers = () => API.get("/api/drivers");

// Funzione per ottenere i dettagli di un corriere specifico
export const getDriverDetails = (driverId) => API.get(`/api/drivers/${driverId}`);

// Funzione per ottenere l'elenco dei veicoli da MongoDB
export const getVehicles = () => API.get("/api/vehicles");

// Funzione per ottenere i dettagli di un veicolo specifico
export const getVehicleDetails = (vehicleId) => API.get(`/api/vehicles/${vehicleId}`);

export default API;